import './MeditationCard.scss'

import { useState } from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import parse from 'html-react-parser'

import AudioBadge from '../AudioBadge'

// this component is highly coupled
const MeditationCard = ({ meditationData, hideCard, className = '' }) => {
  const [timeEstimation, setTimeEstimation] = useState(null)

  const returnTimeEstimation = () =>
    timeEstimation === null ? '' : `${timeEstimation} min`

  return (
    <div
      id='meditation-content-card'
      className={`meditation-content-card px-4 pt-4 ${className}`}
    >
      <Row className='meditation-content-header px-2 pt-3 mb-3'>
        <Col>
          <h2>Introduction</h2>
          <span className='meditation-fullscreen-time-estimated'>
            {returnTimeEstimation()}
          </span>
        </Col>
        <Col className='d-flex justify-content-end align-items-start'>
          <AudioBadge
            audioSource={meditationData?.acf?.spoken_track_url}
            setTimeEstimation={setTimeEstimation}
          />
        </Col>
      </Row>
      <Row className='meditation-content-text px-2'>
        <Col>
          {meditationData?.content && parse(meditationData?.content?.rendered)}
        </Col>
      </Row>
      <Row className='meditation-content-call-for-action px-2'>
        <Button onClick={() => hideCard()} size='lg'>
          Let's meditate
        </Button>
      </Row>
    </div>
  )
}

export default MeditationCard
